"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var useService_1 = require("./useService");
// useRequest 和 useService 相比没有传参params, 只是为了得到封装后的请求方法
var useRequest = function (service, success, fail, final) {
    var _a = __read(useService_1.useServiceCallback(service, success, fail, final), 2), callback = _a[0], _b = _a[1], loading = _b.loading, error = _b.error, response = _b.response;
    return {
        // 请求获取的数据
        response: response,
        // loading状态
        loading: loading,
        // 请求错误信息
        error: error,
        // 请求的方法封装
        request: callback,
    };
};
exports.default = useRequest;
